import { BrandChatFeaturedProduct } from '@storefronts/common-types'

export type InlineQuestion = { label: string; question: string }

/** Two rows of questions for an inline product: what its reviews talk about,
 * then what shoppers ask about any product. Each names the product, since the
 * chat sees the whole storefront. */
export const inlineQuestionRows = (
    title: string,
    product: BrandChatFeaturedProduct | undefined,
): InlineQuestion[][] => {
    const topics = (product?.reviews?.topics ?? []).map(({ label }) => ({
        label,
        question: `What do reviewers say about the ${title}'s ${label.toLowerCase()}?`,
    }))
    const questions = [
        {
            label: 'Is this right for me?',
            question: `Is the ${title} right for me?`,
        },
        {
            label: 'How does it compare?',
            question: `How does the ${title} compare to the others here?`,
        },
        {
            label: 'What should I know before buying?',
            question: `What should I know before buying the ${title}?`,
        },
    ]
    return [topics, questions].filter((row) => row.length > 0)
}
